export { Card } from '../../SessionList/styled';
